export class PinchZoomObserver {
    constructor() {
        this._subscriptions = [];
    }
    emit(data) {
        this._subscriptions.forEach(f => f(data));
    }
    subscribe(callback) {
        if (typeof callback === 'function') {
            this._subscriptions.push(callback);
        }
        return {
            unsubscribe: () => {
                this._subscriptions = this._subscriptions.filter(i => i !== callback);
            },
        };
    }
}
